import React, { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection, $isTextNode, ElementNode, TextNode } from 'lexical';
import { useSelectionStore } from '../../../../EdgeDocs/EdgeDocsCore/stores/useSelectionStore';

function getParagraphAncestor(node: TextNode | ElementNode | null): ElementNode | null {
  let cur: any = node;
  while (cur) {
    try {
      if (typeof cur.getType === 'function' && cur.getType() === 'paragraph') return cur as ElementNode;
      cur = typeof cur.getParent === 'function' ? cur.getParent() : null;
    } catch {
      break;
    }
  }
  return null;
}

export const SelectionBridgePlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext();
  const setSelection = useSelectionStore(s => s.setSelection);

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) { setSelection({ anchor: null, focus: null, source: 'lexical' }); return; }

        const anchorNode = selection.anchor.getNode();
        // const focusNode = selection.focus.getNode();
        const aText = $isTextNode(anchorNode) ? anchorNode : null;
        // const fText = $isTextNode(focusNode) ? focusNode : null;
        const aPara = getParagraphAncestor(aText || (anchorNode as any));
        // const fPara = getParagraphAncestor(fText || (focusNode as any));

        // Single range approximation using anchor side; extended handling can add both
        if (aText && aPara) {
          const aKey = aText.getKey();
          const pKey = aPara.getKey();
          const start = selection.anchor.offset;
          const end = selection.focus.offset;
          const s = Math.min(start, end);
          const e = Math.max(start, end);
          setSelection({ anchor: { blockId: pKey, runId: aKey, offset: s }, focus: { blockId: pKey, runId: aKey, offset: e }, source: 'lexical' });
        } else {
          setSelection({ anchor: null, focus: null, source: 'lexical' });
        }
      });
    });
  }, [editor, setSelection]);

  return null;
};


